@let person = personalData();

<div class="header-wrapper" [class.pdf-mode]="pdfMode()">
  <div class="avatar-container">
    @if (!iOsMode()) {
      <img src="assets/icons/avatar-default_bg.svg">
    }
    <div class="person-name"> {{ person?.name }}</div>
  </div>
  <div class="mt-xxl"></div>

  <div class="person-data">

    <div class="item">
      <div class="label"> {{ getLabel('personalData.birthdate') }}</div>
      <div
        class="text"> {{ !!person?.birthdate ? (person?.birthdate | date : Constants.FORMAT_DATE_PPL) : Constants.DASH }}
      </div>
    </div>
    <div class="item">
      <div class="label"> {{ getLabel('personalData.category') }}</div>
      <div class="text"> {{ person?.category ? person.category : Constants.DASH }}</div>
    </div>

    <div class="item">
      <div class="label"> {{ getLabel('personalData.age') }}</div>
      <div class="text"> {{ person?.age ? person.age : Constants.DASH }}</div>
    </div>
    <div class="item">
      <div class="label"> {{ getLabel('personalData.avhSalary') }}</div>
      <div class="text">
        <span class="currency">{{ Constants.CHF }}</span>
        <span>{{ person?.avhSalary | pasteApostropheAfterEachThreeNums }}</span>
      </div>
    </div>

    <div class="item">
      <div class="label"> {{ getLabel('personalData.jobSum') }}</div>
      <div class="text"> {{ person?.jobSum ? (person?.jobSum + Constants.PERCENT) : 0 }}</div>
    </div>

  </div>

  <div class="mt-xl"></div>

</div>
